import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogActions } from '@mui/material';
import ButtonLoading from '../../../components/ButtonLoading';

interface DialogShareProps {
  close: () => void;
  open: boolean;
  imageToView: string;
}
export default function DialogViewImage({ close, open, imageToView }: DialogShareProps) {

  const [openImage, setOpenImage] = React.useState(false);

  const handleClose = () => {
    close()
    setOpenImage(false)
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        style={{ margin: 48 }}
        open={true}
        onClose={handleClose}
      >
        <DialogContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img
            style={{ objectFit: 'contain', width: '100%', height: '100%' }}
            src={imageToView}
          />
        </DialogContent>

        <DialogActions>
          <ButtonLoading
            label='Fechar'
            isDelete onClick={handleClose}
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}